<template>
  <div class="container">
    <nyTit1 pathUrl="/yuanqu" />
    <div class="content">
      <div class="title">
          <span class="txt1">品牌一产</span>
      </div>
      <div class="Third_content_1">
        <div class="Third_content_1_item">
          <div  class="Third_content_1_sp" v-for="(item, index) in center_data1"  :key="index">
            <img class="Third_content_sp_tup" :src="item.img" />
          </div>
        </div>
        <div class="Third_content_1_item">
          <div  class="Third_content_1_sp" v-for="(item, index) in center_data3"  :key="index">
            <img class="Third_content_sp_tup" :src="item.img" />
          </div>
        </div>
        <div class="Third_content_1_item">
          <div  class="Third_content_1_sp" v-for="(item, index) in center_data2"  :key="index">
            <img class="Third_content_sp_tup" :src="item.img" />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from "three";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
import leftPie from "@/components/yingyangcan/left_pie";
import leftbar from "@/components/pingpai/left_bar";
import { useRouter } from "vue-router";
import popBg from "../components/popBg.vue";
import nyTit1 from "@/components/nyTit1.vue";
export default {
  name: "Home",
  setup() {
    const router = useRouter();
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      center_data1: [
        {
          name: "牛硕奶业",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/jiagong/1.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-1.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "上农实业",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/jiagong/2.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-2.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "久久面粉",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/jiagong/3.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/jjmf.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "益家康食品 ",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/jiagong/4.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/yjksp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "最状元粉条 ",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/jiagong/5.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/slf.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "旷华食品 ",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/jiagong/6.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/khsp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "牛硕奶业",

          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/jiagong/7.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-1.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "上农实业",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/jiagong/8.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-2.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "久久面粉",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/jiagong/9.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/jjmf.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        ],
      center_data2: [
        {
          name: "最状元粉条 ",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/zhongzhi/1.jpg",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/12.gif", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "旷华食品 ",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/zhongzhi/2.png ",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/khsp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "牛硕奶业",

          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/3.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-1.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "上农实业",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/14.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-2.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "旷华食品 ",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/18.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/khsp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "牛硕奶业",

          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/19.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-1.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "上农实业",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/20.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/3c-2-2.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "益家康食品 ",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/22.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/yjksp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "久久面粉",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/6.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/jjmf.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        ],
      center_data3: [
        {
          name: "最状元粉条 ",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/yangzhi/2.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/slf.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "羊 ",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/26.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/khsp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "羊 ",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/33.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/yjksp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "羊 ",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/yangzhi/1.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/slf.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "羊 ",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/31.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/khsp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "羊",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/yangzhi/4.png",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/jjmf.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "羊 ",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/16.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/yjksp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "羊 ",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/17.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/slf.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
         {
          name: "鸽子 ",
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/27gif/10.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/yyc/yjksp.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
      ],
    });
    onMounted(() => {
      init();
      animate();
    });
    onUnmounted(() => {
      // 清理资源
      // renderer.dispose();
    });
    // 弹出视频
    function videoClick(index1, type) {
      console.log(index1);
      state.popShow = true;
      state.curVideoIndex = index1;
      state.type = type;
    }
    // 关闭弹出
    function popHiddlen() {
      state.popShow = false;
    }

    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
    // 返回上一页
    function clickReturn() {
      console.log("上一页");
      router.go(-1);
    }
    function close() {
      state.isShow = !state.isShow;
    }
    // 旋转
    function init() {
      // 初始化渲染器
    }
    function animate() {}
    return {
      ...toRefs(state),
      close,
      clickReturn,
      videoClick,
      popHiddlen,
    };
  },
  components: {
    nyTit1,
    leftPie,
    leftbar,
    popBg,
  },
};
</script>

<style lang="less" scoped>
a {
  display: block;
  width: 100%;
  height: 100%;
}
.container {
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/bj.jpg")
    no-repeat top center;
  background-size: 100% 100% !important;
  color: #fff;
  position: relative;

  //4个区域内容的标题
  .First .title {
    background: url("../assets/img/shancaixianqing/xq/bt2.png") no-repeat;
  }
  .title {
    width: 100%;
    height: 70px;
    padding-left: 50px;
    box-sizing: border-box;
    line-height: 70px;
    color: #fff;
    background: url("../assets/img/pingpai/v1/2bt.png") no-repeat;
    display: flex;
    span {
      display: block;
    }
    .txt1 {
      font-size: 42px;
      background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-style: italic;
      font-weight: bold;
      padding: 0 10px;
    }
  }
  //公共标题区域
  .xiao_biao_ti {
    width: 100%;
    height: 55px;
    background: #072d50;
    font-size: 30px;
    text-align: left;
    display: flex;
    //justify-content: center;
    align-items: center;
    text-indent: 1em;
    margin-top: 15px;
  }

  //右侧公共标题
  .titles1 {
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    img {
      width: 160px;
      height: 160px;
    }
    span {
      font-size: 42px;
      background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-style: italic;
      font-weight: bold;
      padding: 0 10px;
      text-indent: 1em;
    }
  }
  // 内容区域
  .content {
    position: absolute;
    top: 220px;
    left: 0;
    width: 100%;

    height: calc(100% - 210px);
    display: flex;
    position: relative;
    padding: 20px 80px 48px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .Third_content_1_item{
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: space-between;
      margin: 0 0.5%;
    }
    .Third_content_1 {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 50px 50px;
        .Third_content_1_sp {
          width: 30%;
          margin: 0 0.5%;
          height: 27%;
          background: url("../assets/img/pingpai/v2/spk.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: relative;
          padding: 20px 16px;
          box-sizing: border-box;
          overflow: hidden;
          margin: 10px 0;
          .Third_content_sp_tup {
            width: 100%;
            height: 100%;
          }
          span {
            width: 100%;
            font-size: 42px;
            height: 60px;
            padding: 0 10px;
            line-height: 60px;
            // text-indent: 1em;
            position: absolute;
            color: #fff;
            left: 0%;
            // top: 45%;
            bottom: 2%;
            z-index: 2;
            background: rgba(20, 54, 102, 0.6);
          }
        }
      }

  }
}
</style>
